import React from 'react'
import getConfig from 'next/config'
import { iscPreset } from '@ycos/coremedia-renderer'
import CoremediaPage from '@ycos/nextjs/src/components/CoremediaPage'
import Image from '@ycos/component-image'
import EditorialLayout from '../layouts/EditorialLayout'
import { Collection, Section, ThreeColumnItemList , SingleColumn } from '@ycos/component-columns'
import StandardVideo from '@ycos/component-video'
import CallToAction from '@ycos/component-cta'
import ContentCarousel from '@ycos/component-content-carousel'
import { Block } from '../src/components/component-block'
import CenteredCta from '../src/components/component-cta/CenterdCta'
import TakeOver from '../src/components/component-takeover'
import OverlapSection from '../src/components/component-overlap-section'
import { OneColumn, TwoColumn, ThreeColumn, FourColumn, FourColumnHomepage, ThreeColumnMasonry } from '../src/components/component-columns'
import ImageGrid from '../src/components/component-image-grid'
import {
  WirePids,
  siteMerchandisingRule,
  imagesphereUrlRule,
  siteMerchandisingAdditionalCTARules,
  siteMerchandisingProductsRule,
  addOnTargetClickEditorial
} from '../src/rules'
import ProductCarousel from '../src/components/component-product-carousel'
import ProductFeed from '../src/components/component-product-feed'
import { Picture } from '@ycos/picture'
import LoyaltyCreateAccountOptIn from '@ycos/component-loyalty-create-account-opt-in'


const { publicRuntimeConfig } = getConfig()
const siteMerchandisingItems = []
const siteMerchandisingListing = { item: [] }
const optionalRules = (props) => [
  imagesphereUrlRule(publicRuntimeConfig.imageSphere.baseUrl),
  siteMerchandisingRule(siteMerchandisingItems, props.page, publicRuntimeConfig),
  siteMerchandisingAdditionalCTARules(siteMerchandisingItems, props.page, publicRuntimeConfig),
  siteMerchandisingProductsRule(siteMerchandisingListing, props.products, publicRuntimeConfig),
  addOnTargetClickEditorial(props.page, publicRuntimeConfig)
]

export default CoremediaPage({
  layout: ({ children, locale, ...rest }) => {
    return (
      <EditorialLayout
        locale={locale}
        siteMerchandisingItems={siteMerchandisingItems}
        publicRuntimeConfig={publicRuntimeConfig}
        siteMerchandisingListing={siteMerchandisingListing}
        {...rest}
      >
        {children}
      </EditorialLayout>
    )
  },
  getAdditionalProps: ({ req }) => {
    return {
      products: req.products
    }
  },
  rules: (props) => {
    const { isPreview, locale, webview, products } = props
    const { gtmAnalytics, productUrl, brand, personalisation } = publicRuntimeConfig

    return [
      ...iscPreset(publicRuntimeConfig, {
        gtmAnalytics,
        productUrl,
        isPreview,
        locale,
        webview,
        brand,
        products,
        personalisation
      }),
      WirePids(products),
      ...optionalRules(props)
    ]
  },
  components: [
    // add more components here
    Block,
    ProductCarousel,
    ProductFeed,
    LoyaltyCreateAccountOptIn,
    Collection,
    Section,
    CallToAction,
    CenteredCta,
    Collection,
    FourColumn,
    Image,
    OneColumn,
    Picture,
    Section,
    TwoColumn,
    ThreeColumn,
    ThreeColumnItemList,
    FourColumnHomepage,
    OverlapSection,
    Section,
    OverlapSection,
    TakeOver,
    StandardVideo,
    ThreeColumnMasonry,
    ImageGrid,
    ContentCarousel,
    SingleColumn
  ]
})
